import { Pager } from '../common/pagination.model';
import { ProductVariant } from './product.model';

export interface InfluencerPublicTranslation {
  language: string;
  name: string;
}

export interface InfluencerPublicBannerImage {
  image_url: string | null;
}

export interface InfluencerPublicBannerViewType {
  desktop?: InfluencerPublicBannerImage | null;
  mobile?: InfluencerPublicBannerImage | null;
}

export interface InfluencerPublicBannerTranslation {
  __key?: string;
  id?: string | null;
  language: string;
  carousel_item_id?: string | null;
  view_type: InfluencerPublicBannerViewType;
  createdAt?: string;
  updatedAt?: string;
}

export interface InfluencerPublicBanner {
  id: string;
  position: number;
  banner_type: string;
  entity_type: string;
  banner_value: string;
  banner_slug: string | null;
  translation: InfluencerPublicBannerTranslation;
  influencer_id: string;
  influencer_slug: string | null;
}

export interface InfluencerPublicBannersResponse {
  records: InfluencerPublicBanner[];
}

export interface InfluencerPublicActiveInfluencer {
  id: string;
  slug: string;
  translation: InfluencerPublicTranslation;
  profile_image_url: string;
}

export interface InfluencerPublicActiveInfluencersResponse {
  records: InfluencerPublicActiveInfluencer[];
}

export type InfluencerPublicDetailedListProduct = ProductVariant;

export interface InfluencerPublicDetailedListVideo {
  id: string;
  video_url: string;
  thumbnail_url: string | null;
  is_primary: boolean;
  position: number;
  linked_products: InfluencerPublicDetailedListProduct[];
}

export interface InfluencerPublicDetailedListRecord {
  id: string;
  slug: string;
  name: string;
  profile_image_url: string | null;
  spoken_languages: string[];
  desktop_cover_banner_url: string | null;
  mobile_cover_banner_url: string | null;
  desktop_section_banner_url: string | null;
  mobile_section_banner_url: string | null;
  videos_count: number;
  products_linked: number;
  videos: InfluencerPublicDetailedListVideo[];
}

export interface InfluencerPublicDetailedListResponse extends Pager {
  records: InfluencerPublicDetailedListRecord[];
}

export interface InfluencerPublicDetailedListParams {
  page?: number;
  limit?: number;
  influencer_id?: number | string;
  influencer_slug?: string;
  spoken_language?: string;
}

export interface InfluencerPublicFilterOption {
  id: string;
  slug: string;
  name: string;
}

export interface InfluencerPublicFilterOptionsResponse {
  influencers: InfluencerPublicFilterOption[];
  spoken_languages: string[];
}

export interface InfluencerPublicDetail {
  id: string;
  slug: string;
  name: string;
  profile_image_url: string | null;
  show_in_carousel: boolean;
  spoken_languages: string[];
  desktop_cover_banner_url: string | null;
  mobile_cover_banner_url: string | null;
  desktop_section_banner_url: string | null;
  mobile_section_banner_url: string | null;
}

export interface InfluencerPublicDetailResponse {
  influencer: InfluencerPublicDetail;
}

export interface InfluencerPublicCategory {
  id: string | null;
  slug: string | null;
  key: string;
  translation: InfluencerPublicTranslation;
  icon_url: string | null;
}

export type InfluencerPublicCategoryVideoProduct = ProductVariant;

export interface InfluencerPublicCategoryVideo {
  id: string;
  video_url: string;
  thumbnail_url: string | null;
  is_primary: boolean;
  position: number;
  linked_products: InfluencerPublicCategoryVideoProduct[];
}

export interface InfluencerPublicCategoryVideosResponse extends Pager {
  category: InfluencerPublicCategory;
  records: InfluencerPublicCategoryVideo[];
}

export interface InfluencerPublicCategoryVideosParams {
  page?: number;
  limit?: number;
}
